import React from "react";
import "./EllipsisText.scss";
import {Tooltip} from "antd";


export default function EllipsisText({ text }) {
  return (
    <Tooltip title={text} placement={"top"}>
      <div className="ellipsis-text">
        {text}
      </div>
    </Tooltip>
  );
}
